/**
 * Which discipline this screen belongs to, in its own colour. Shown on every project
 * list and workspace, so the colour always has a name beside it.
 */

import type { Discipline } from '../disciplines';

export function DisciplineChip({ discipline }: { discipline: Discipline }) {
  return (
    <span
      data-discipline={discipline.id}
      className="inline-flex items-center gap-1.5 rounded-full bg-accent-50 px-2.5 py-0.5 text-xs font-semibold text-accent-700 ring-1 ring-inset ring-accent-200"
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-accent-600" />
      {discipline.label}
    </span>
  );
}
